import React, { FC } from 'react';
import classnames from 'classnames';
import { IProductLabel } from 'api/types';
import styles from 'theme/components/controls/Label/Label.module.scss';
import { LabelIcons } from './labelIcons';

interface IProps {
  label: IProductLabel;
}

// Mapowanie typów z API na znormalizowane wartości (używane do ikon i klas CSS)
const TYPE_NORMALIZE_MAP: Record<string, { iconKey: string; cssClass: string }> = {
  'NEW': { iconKey: 'NOWOSC', cssClass: 'new' },
  'NOWY': { iconKey: 'NOWOSC', cssClass: 'new' },
  'NOWOSC': { iconKey: 'NOWOSC', cssClass: 'new' },
  'PROMOTION': { iconKey: 'PROMOCJA', cssClass: 'promotion' },
  'PROMOCJA': { iconKey: 'PROMOCJA', cssClass: 'promotion' },
  'BESTSELLER': { iconKey: 'BESTSELLER', cssClass: 'bestseller' },
  'BEZ_SUP': { iconKey: 'BEZ_SUP', cssClass: 'bezSup' },
  'TWOJ_NADRUK': { iconKey: 'TWOJ_NADRUK', cssClass: 'twojNadruk' },
  'PREMIUM': { iconKey: 'PREMIUM', cssClass: 'premium' }
};

const Label: FC<IProps> = ({ label }) => {
  const labelType = (label.type || label.name || '').toUpperCase();
  const normalized = TYPE_NORMALIZE_MAP[labelType];
  const cssClass = normalized?.cssClass || labelType.toLowerCase();
  const iconKey = normalized?.iconKey || labelType;
  const icon = LabelIcons[iconKey];

  return (
    <span
      className={classnames(
        styles.componentWrapper,
        styles[cssClass],
        'StylePath-Components-Controls-Label'
      )}>
      {icon || <span className={styles.labelText}>{label.name}</span>}
    </span>
  );
};

export default Label;

